import Ably from "ably";

const state = {
  ablyChannel: null,
};

const getters = {
  ablyChannel: (state) => {
    return state.ablyChannel;
  },
};

const mutations = {
  setAblyChannel: (state, ablyChannel) => {
    state.ablyChannel = ablyChannel;
  },
};

const actions = {
  establishDataChannel: async (context, data) => {
    const sessionId = data.sessionId;
    const authToken = data.token;
    const ably = new Ably.Realtime({
      authUrl: process.env.VUE_APP_ABLY_TOKEN_ENDPOINT,
      authParams: { sessionId },
      authHeaders: { Authorization: `Bearer ${authToken}` },
    });
    const channelId = data.id;
    const ch = ably.channels.get(channelId);
    context.commit("setAblyChannel", ch);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
